module.exports = __webpack_public_path__ + "static/media/Project-Education.21111c14.svg";